// extracted by mini-css-extract-plugin
export default {"container":"Header--container--R-v2A","isScrolling":"Header--isScrolling--LW5RU","menu":"Header--menu--CaRj2","items":"Header--items--ZjIvC"};